import { render, staticRenderFns } from "./WkTableItems.vue?vue&type=template&id=4f4939b4&scoped=true&"
import script from "./WkTableItems.vue?vue&type=script&lang=js&"
export * from "./WkTableItems.vue?vue&type=script&lang=js&"
import style0 from "./WkTableItems.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WkTableItems.vue?vue&type=style&index=1&id=4f4939b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4939b4",
  null
  
)

component.options.__file = "WkTableItems.vue"
export default component.exports